function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var rm = function rm(hs, t, h, strict) {
  if (hs) {
    var e,
      i = hs.length;
    while (i--) {
      e = hs[i];
      if ((e.t === t || t === null && !strict) && (h === e.h || h === null && !strict)) {
        hs.splice(i, 1);
        if (strict) {
          return true;
        }
      }
    }
  }
  return !strict;
};

/**
 * Event callback
 * @callback EventBus~eventCallback
 * @param {?object} data Event data object
 * @param {object} target Target object
 * @param {string} event Event name including namespace
 * @param {?string} action Event action. This is the suffix of the event being listened to, or null if listening to the actual event.
 */

/**
 * EventBus is a bus for subscribing to and emitting events.
 */
var EventBus = /*#__PURE__*/function () {
  /**
   * Creates an event bus.
   */
  function EventBus() {
    _classCallCheck(this, EventBus);
    this._evs = {};
    this._qh = null;
  }

  /**
   * Attach an event handler function for one or more events.
   * @param {object} [target] An optional target object. The handler will only be called if target matches the target of the emitted event.
   * @param {?string} events One or more space-separated events (eg. 'disconnect'). Null or empty means any event.
   * @param {EventBus~eventCallback} handler A function to execute when the event is emitted.
   * @param {string} [namespace] Namespace string that will be added, separated with a dot, to every event name. If no events is null, only events with that namespace will be affected.
   * @returns {this}
   */
  _createClass(EventBus, [{
    key: "on",
    value: function on(target, events, handler, namespace) {
      var i, hs, name, h;

      // Detect optional parameters
      if (typeof events == 'function') {
        // (events, handler, namespace)
        namespace = handler;
        handler = events;
        events = target;
        target = null;
      }
      h = {
        t: target || null,
        h: handler
      };
      if (!events) {
        name = namespace || "";
        hs = this._evs[name];
        if (!hs) {
          this._evs[name] = [h];
        } else {
          hs.push(h);
        }
      } else {
        namespace = namespace ? namespace + '.' : '';

        // Handle multiple events separated by a space
        events = events.match(/\S+/g) || [];
        for (i = 0; i < events.length; i++) {
          name = namespace + events[i];
          hs = this._evs[name];
          if (!hs) {
            this._evs[name] = [h];
          } else {
            hs.push(h);
          }
        }
      }
      return this;
    }

    /**
     * Remove an event handler.
     * @param {object} [target] An optional target object. The handler will only be removed if target matches the target of the handler.
     * @param {?string} events One or more space-separated events (eg. 'disconnect'). Null or empty means any event.
     * @param {function} [handler] An option handler function. The handler will only be remove if it is the same handler.
     * @param {string} [namespace] Namespace string that will be added, separated with a dot, to every event name.
     * @param {boolean} [strict] Flag for strict mode where an error will be thrown if the handler doesn't exist.
     * @returns {this}
     */
  }, {
    key: "off",
    value: function off(target, events, handler, namespace, strict) {
      var i, hs, name;

      // Detect optional parameters
      if (target === null || typeof target == 'string') {
        // (events, handler, namespace)
        strict = namespace;
        namespace = handler;
        handler = events;
        events = target;
        target = null;
      }
      if (!events) {
        events = [namespace || ""];
        namespace = "";
      } else {
        namespace = namespace ? namespace + '.' : '';
        // Handle multiple events separated by a space.
        events = events.match(/\S+/g) || [];
      }
      for (i = 0; i < events.length; i++) {
        name = namespace + events[i];
        hs = this._evs[name];
        if (!rm(hs, target, handler, strict)) {
          var err = new Error("Event handler not found");
          console.error(err, {
            target: target,
            events: events,
            handler: handler,
            namespace: namespace
          });
          throw err;
        }
        // No event handlers for event
        if (!hs) {
          continue;
        }
        // Delete array if empty
        if (!hs.length) {
          delete this._evs[name];
        }
      }
      return this;
    }

    /**
     * Emits an event and triggers the base handler to be called, followed by any other handler bound.
     * @param {object} [target] Target object of the event
     * @param {string} event Name of the event. May include the namespace, if the namespace parameter is not provided.
     * @param {object} [data] Event data object. May be modified by the base handler, but shouldn't be changed any other handler.
     * @param {string} [namespace] Namespace string that will be added, separated with a dot, before the event name.
     * @returns {this}
     */
  }, {
    key: "emit",
    value: function emit(target, event, data, namespace) {
      var i, hs, h, sub, action;

      // Detect optional parameters
      if (typeof target == 'string') {
        // (events, data, namespace)
        namespace = data;
        data = event;
        event = target;
        target = null;
      }
      event = (namespace ? namespace + '.' : '') + event;
      sub = event;
      while (true) {
        hs = this._evs[sub];
        if (hs) {
          action = (sub ? event.substr(sub.length + 1) : event) || null;
          i = hs.length;
          while (i--) {
            h = hs[i];
            if (typeof h.h == 'function' && (h.t === null || h.t == target)) {
              this._exec([data, target, event, action, h.h]);
            }
          }
        }
        if (!sub) {
          break;
        }

        // Remove last namespace part
        i = sub.lastIndexOf('.');
        sub = i == -1 ? "" : sub.substr(0, i);
      }
      return this;
    }
  }, {
    key: "_exec",
    value: function _exec(cb) {
      var _this = this;
      if (this._qh) {
        this._qh.push(cb);
        return;
      }
      this._qh = [cb];
      setTimeout(function () {
        var f;
        while (cb = _this._qh.shift()) {
          f = cb.pop();
          try {
            f.apply(void 0, _toConsumableArray(cb));
          } catch (e) {
            console.error(e);
          }
        }
        _this._qh = null;
      }, 0);
    }
  }]);
  return EventBus;
}();
export default EventBus;